import type { IdNameDto } from '../../Shared/Types/common';

export type ReportsCompanyLookup = IdNameDto;

interface ReportsCompanyLookupSource {
  id: number;
  name?: string | null;
}

export const mapCompanyToReportsLookup = (
  company: ReportsCompanyLookupSource
): ReportsCompanyLookup | undefined => {
  const normalizedName = company.name?.trim();
  if (!normalizedName) {
    return undefined;
  }

  return {
    id: company.id,
    name: normalizedName,
  };
};
